import { LoginService } from "./@core/data/login.service";
/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from "@angular/core";
import { environment } from "../environments/environment";

import { AnalyticsService } from "./@core/utils/analytics.service";
import { SeoService } from "./@core/utils/seo.service";

import { GeneralService } from "./@core/data/general.service";
import { StorageService } from "./@core/data/storage.service";
import { VersionCheckService } from "./@core/data/version-check.service";

import { NbMenuItem } from "@nebular/theme";
import { Home } from "./@core/models/home";
import { AppUser } from "./@core/models/app.user";
import { NavigationEnd, Router } from "@angular/router";

@Component({
  selector: "edm-app",
  template: `
    <router-outlet></router-outlet>
    <div class="reminder-app">
      <edm-reminder-app></edm-reminder-app>
    </div>
    <edm-cookie-consent></edm-cookie-consent>
  `,
  standalone: false,
})
export class AppComponent implements OnInit {
  menu: NbMenuItem[] = [];

  constructor(
    private analytics: AnalyticsService,
    private seoService: SeoService,
    private generalService: GeneralService,
    private storageService: StorageService,
    private loginService: LoginService,
    private router: Router,
    private versionCheckService: VersionCheckService,
  ) {
    this.menu = this.generalService.mobileMenu();
    if (environment.production) this.loadStyles();
    this.storageService.storeObject(null, "app_logged_user");
    this.storageService.clear("app_logged_user");
    this.storageService.storeObject(null, "home_config");
    this.storageService.clear("home_config");
    // Reset product scroll-restore state on hard reload (F5 / fresh tab).
    this.generalService.purge("product_scroll_state");

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const currentUrl = this.router.url;

        // Drop product scroll-restore state whenever we navigate outside the
        // product subtree (/produtos/:id and its lesson children).
        const pathOnly: string = currentUrl.split("?")[0];
        if (!/^\/produtos\/\d+(\/|$)/.test(pathOnly)) {
          this.generalService.purge("product_scroll_state");
        }

        if (currentUrl.includes("atividades")) return;

        if (
          !currentUrl.includes("comunidade") &&
          !currentUrl.includes("perfil")
        ) {
          sessionStorage.removeItem("navigationStack");
          return;
        }

        const rawStack = sessionStorage.getItem("navigationStack");
        let stack: string[] = rawStack ? JSON.parse(rawStack) : [];

        const base = this.getBasePath(currentUrl);

        stack = stack.filter((url) => !this.getBasePath(url).startsWith(base));

        if (!stack.includes(currentUrl)) {
          stack.push(currentUrl);
        }

        sessionStorage.setItem("navigationStack", JSON.stringify(stack));
      }
    });
  }

  private getBasePath(url: string): string {
    const parts = url.split("/").filter(Boolean);
    return parts.length >= 2 ? `/${parts[0]}/${parts[1]}` : url;
  }

  ngOnInit(): void {
    this.generalService.browserDetectionClass();
    if (environment.production) {
      this.analytics.trackPageViews();
      this.seoService.trackCanonicalChanges();
      // Detecta deploy novo com aba aberta (sem service worker) e avisa via toast.
      this.versionCheckService.startPolling();
    }

    if (this.loginService.isAuthenticated()) {
      this.loginService.loggedUser().then((loggedUser: AppUser): void => {
        this.storageService.storeObject(loggedUser, "app_logged_user");
        this.loginService.loggedUser$.next(loggedUser);
      });
      this.loginService.user$.next(true);
    }

    this.generalService.home().then((home: Home): void => {
      this.storageService.storeObject(home, "home_config");
      this.generalService.home$.next(home);
    });

    setTimeout(() => {
      var ua = navigator.userAgent;

      var isIOS = /iPad|iPhone|iPod/.test(ua) && !(window as any).MSStream;
      var isChrome = /CriOS/.test(ua); // Chrome no iOS usa 'CriOS'

      if (isIOS && isChrome) {
        const container = document.querySelector(
          "nb-layout-column",
        ) as HTMLElement | null;
        if (container) {
          container.style.setProperty("padding-top", "20px", "important");
        }
      }
    }, 500);
  }

  private loadStyles(): void {
    const head: HTMLHeadElement = document.head;
    const socialCSS: HTMLLinkElement = document.getElementById(
      "comunidade-css",
    ) as HTMLLinkElement;
    if (!this.exists(socialCSS)) {
      let newSocialCss: HTMLLinkElement = document.createElement("link");
      newSocialCss.id = "comunidade-css";
      newSocialCss.rel = "stylesheet";
      newSocialCss.href = "/assets/comunidade/comunidade.css";
      head.appendChild(newSocialCss);
    }
    const videoCSS: HTMLLinkElement = document.getElementById(
      "video-css",
    ) as HTMLLinkElement;
    if (!this.exists(videoCSS)) {
      let newSocialCss: HTMLLinkElement = document.createElement("link");
      newSocialCss.id = "video-css";
      newSocialCss.rel = "stylesheet";
      newSocialCss.href = "/video/video.css";
      head.appendChild(newSocialCss);
    }
  }

  private exists(element: any): boolean {
    return element !== null && element !== undefined;
  }
}
